import axios from "axios";

const backendUrlPut = process.env.REACT_APP_BACKEND_RESUME_URL;

const PutResume = async (rid, putBody, token) => {
  const headers = {
    "Content-Type": "application/json",
    token: token,
    rid: rid,
  };
  try {
    const response = await axios.put(backendUrlPut, putBody, { headers })
    return response.data
  } catch (error) {
    return error;
  }

};

export default PutResume;
